import { apiConfig } from "./apiConfig";
import {
  filterEliteMarketingRecords,
  buildEliteMarketingPayload,
  buildMarketingFilterContext,
} from "../utils/marketingElite";

const saveClickPromo = async (payload) => {
  return await apiConfig.post("/marketing/create", payload);
};

const saveClickPromoElite = async (payload) => {
  return await apiConfig.post(
    "/marketing/create",
    buildEliteMarketingPayload(payload),
  );
};

const getAnalytics = async () => {
  return await apiConfig.get("/marketing");
};

const getAnalyticsElite = async () => {
  const [marketingRes, bannersRes] = await Promise.all([
    apiConfig.get("/marketing"),
    apiConfig.get("/banners"),
  ]);

  const context = buildMarketingFilterContext(bannersRes.data);
  const data = filterEliteMarketingRecords(marketingRes.data, context);

  return { ...marketingRes, data };
};

export { saveClickPromo, saveClickPromoElite, getAnalytics, getAnalyticsElite };
